import { c as _c } from "react/compiler-runtime";
import { parseProseBlocks } from "@/lib/parseProseBlocks";
import styles from "@/styles/Home.module.css";
type ProseTextProps = {
  text: string;
  className?: string;
};

/** Renders plain copy with paragraphs and bullet lists. */
export function ProseText(t0) {
  const $ = _c(10);
  const {
    text,
    className
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== className || $[1] !== text) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const blocks = parseProseBlocks(text);
      if (blocks.length === 0) {
        t3 = null;
        break bb0;
      }
      if (blocks.length === 1 && blocks[0].type === "p") {
        t3 = <p className={className ?? styles.productAboutText}>{blocks[0].text}</p>;
        break bb0;
      }
      const t4 = `prose-content ${className ?? styles.productAboutText}`;
      if ($[5] !== t4) {
        t1 = t4.trim();
        $[5] = t4;
        $[6] = t1;
      } else {
        t1 = $[6];
      }
      t2 = blocks.map(_temp2);
    }
    $[0] = className;
    $[1] = text;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t2) {
    t4 = <div className={t1}>{t2}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
function _temp2(block, i) {
  return block.type === "p" ? <p key={`p-${i}`}>{block.text}</p> : <ul key={`ul-${i}`}>{block.items.map(_temp)}</ul>;
}
function _temp(item) {
  return <li key={item}>{item}</li>;
}